<template>
    <v-layout align-center justify-center row pa-5 mb-8>
        <v-flex xs12 sm10 md6>
            <div class="mb-5 text-center">
                <h1>รายละเอียดผู้รับ</h1>
            </div>
            <div>
                <v-text-field label="ค้นหา บ้านเลขที่ หรือ ยูนิต"
                              placeholder="ค้นหา บ้านเลขที่ หรือ ยูนิต"
                              outlined
                              :error="error"
                              append-outer-icon="mdi-magnify"
                              @click:append-outer="searchDataCustomer()"
                              @keypress.enter="searchDataCustomer()"
                              v-model="searchText">
                </v-text-field>
            </div>
            <div v-if="items.length > 0 || filterText" class="mb-8 text-center">
                <v-btn color="#43A047" dark @click="dialog = true">
                    พิมพ์ชื่อ-สกุล
                    <v-icon class="ml-2">mdi-pencil</v-icon>
                </v-btn>
            </div>
            <div v-if="items.length > 0 || filterText">
                <v-text-field label="ค้นหา"
                              placeholder="ค้นหา"
                              v-model="filterText">
                </v-text-field>
            </div>
            <div class="my-2" v-for="(item, key) in items" :key="key" v-if="items.length > 0">
                <v-row>
                    <v-col cols="11">
                        <v-card class="mx-auto my-auto"
                                @click="selectedCustomer(item,'select')"
                                style="border-left:solid 5px #0045AF;background: #e7e8ea">
                            <v-row class="pl-2">
                                <v-col class="text-center my-auto" cols="3">
                                    <v-avatar color="#0D47A1" size="45">
                                        <span class="white--text headline">{{ item.cs_fullname.charAt(0) }}</span>
                                    </v-avatar>
                                </v-col>
                                <v-col cols="6">
                                    <v-card-title>{{ item.cs_fullname }}</v-card-title>
                                    <v-card-text style="color: #000000"
                                                 v-if="item.cs_mobile !== '' && item.cs_mobile !== null">
                                        เบอร์โทร : {{ item.cs_mobile }}
                                    </v-card-text>
                                    <v-card-text style="color: #ff2e34" v-else>ไม่พบเบอร์โทร</v-card-text>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="1" class="pt-5">
                        <v-btn icon @click="selectedCustomer(item,'delete')">
                            <v-icon medium color="#E53935">mdi-delete</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
            <div v-if="items.length === 0 && search" class="my-8 text-center">
                <h3>ไม่พบรายชื่อในบ้านเลขที่นี้</h3>
            </div>
            <v-dialog v-model="dialog" max-width="290" persistent>
                <v-card>
                    <v-card-title>เพิ่มชื่อผู้รับพัสดุ</v-card-title>
                    <v-card-text>
                        <v-text-field label="ชื่อ-สกุล"
                                      outlined
                                      v-model="name">
                        </v-text-field>
                    </v-card-text>
                    <v-card-text>
                        <v-text-field label="เบอร์โทร"
                                      outlined
                                      type="number"
                                      v-model="tel">
                        </v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn color="green darken-1" text @click="selectedNewCustomer()">
                            ตกลง
                        </v-btn>
                        <v-btn color="red darken-1" text @click="dialog = false">
                            ยกเลิก
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_mobile" max-width="290" persistent>
                <v-card>
                    <v-card-title>รายการนี้ไม่มีหมายเลขโทรศัพท์</v-card-title>
                    <v-card-text style="color: #ff2e34">
                        * หมายเหตุเบอร์โทรนี้ใช้ในการส่ง SMS สำหรับเปิดตู้
                    </v-card-text>
                    <v-card-text>
                        <v-text-field label="หมายเลขโทรศัพท์"
                                      placeholder="08xxxxxxxx"
                                      outlined
                                      v-model="tel"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn color="green darken-1" text @click="selectedNewCustomerMobile()">
                            ตกลง
                        </v-btn>
                        <v-btn color="red darken-1" text @click="dialog_mobile = false">
                            ยกเลิก
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_delete" max-width="290" persistent>
                <v-card>
                    <v-card-title>
                        ยืนยันการลบรายชื่อพัสดุ
                    </v-card-title>
                    <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn color="green darken-1" text @click="deleteCustomer()">
                            ตกลง
                        </v-btn>
                        <v-btn color="red darken-1" text @click="dialog_delete = false">
                            ยกเลิก
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from "@/axios";
import EventBus from '@/EventBus'

export default {
    name: "Step5",
    data() {
        return {
            searchText: '',
            items: [],
            itemsDefault: [],
            itemSelect: [],
            dialog: false,
            dialog_mobile: false,
            dialog_delete: false,
            error: false,
            disabled: true,
            search: false,
            name: '',
            tel: '',
            filterText: ''
        }
    },
    methods: {
        async searchDataCustomer() {
            try {
                axios.post("/GetDataCustomer", {
                    searchText: this.searchText,
                    nt_runno: this.getLocalItem().nt_runno,
                }).then((res) => {
                    this.disabled = false
                    this.items = res.data.data
                    this.itemsDefault = res.data.data
                    this.search = true
                    console.log('searchDataCustomer', res.data.data)
                });
            } catch (err) {
                console.log("CheckBarcode", err.message);
            }
        },
        selectedCustomer(data, type) {
            this.itemSelect = data
            if (data.cs_mobile && type === 'select') {
                let params = {step: 5, isData: true, dataSelect: data, cus_new: 'false'}
                EventBus.$emit('step_submit', params)
            } else if (type === 'delete') {
                this.dialog_delete = true
            } else {
                this.dialog_mobile = true
            }
        },
        selectedNewCustomer() {
            this.dialog = false
            let data = this.items[0]
            data.cs_fullname = this.name
            data.cs_mobile = this.tel
            let params = {step: 5, isData: true, dataSelect: data, cus_new: 'true'}
            EventBus.$emit('step_submit', params)
            this.searchDataCustomer()
        },
        selectedNewCustomerMobile() {
            this.dialog_mobile = false
            let data = this.itemSelect
            data.cs_mobile = this.tel
            let params = {step: 5, isData: true, dataSelect: data, cus_new: 'false'}
            EventBus.$emit('step_submit', params)
        },
        async deleteCustomer() {
            console.log('deleteCustomer', this.itemSelect.cs_runno, this.itemSelect.cs_db)

            try {
                axios.post("/DeleteCustomer", {
                    cs_runno: this.itemSelect.cs_runno,
                    cs_db: this.itemSelect.cs_db,
                    pd_addr: this.itemSelect.pd_addr,
                    nt_runno: this.getLocalItem().nt_runno,
                    username: this.getLocalItem().user_id,
                }).then((res) => {
                    this.dialog_delete = false
                    console.log('searchDataCustomer', res.data.data)
                    this.searchDataCustomer()
                });
            } catch (err) {
                console.log("CheckBarcode", err.message);
            }
        }
    },
    watch: {
        filterText: function (val) {
            if (val) {
                this.items = this.filterObject(this.itemsDefault, 'cs_fullname', this.filterText)
            } else {
                this.items = this.itemsDefault
            }
        }
    }
}
</script>

<style scoped>
.col-11 {
    padding: 0 12px 0 12px;
}
</style>